__turbopack_context__.v({
  "body": "DoyeEa_body",
  "cancelButton": "DoyeEa_cancelButton",
  "closeButton": "DoyeEa_closeButton",
  "contactsLabel": "DoyeEa_contactsLabel",
  "container": "DoyeEa_container",
  "errorMessage": "DoyeEa_errorMessage",
  "footer": "DoyeEa_footer",
  "footerButton": "DoyeEa_footerButton",
  "header": "DoyeEa_header",
  "headerTitle": "DoyeEa_headerTitle",
  "infoIcon": "DoyeEa_infoIcon",
  "input": "DoyeEa_input",
  "inputError": "DoyeEa_inputError",
  "label": "DoyeEa_label",
  "saveButton": "DoyeEa_saveButton",
  "scopeLabel": "DoyeEa_scopeLabel",
  "scopeRow": "DoyeEa_scopeRow",
  "section": "DoyeEa_section",
  "submitError": "DoyeEa_submitError",
  "tagsIcon": "DoyeEa_tagsIcon",
  "tagsLabel": "DoyeEa_tagsLabel",
  "tagsRow": "DoyeEa_tagsRow",
  "tagsSection": "DoyeEa_tagsSection",
  "tagsUnsupported": "DoyeEa_tagsUnsupported",
  "templateBody": "DoyeEa_templateBody",
  "templateBorder_info": "DoyeEa_templateBorder_info",
  "templateBorder_success": "DoyeEa_templateBorder_success",
  "templateBorder_urgent": "DoyeEa_templateBorder_urgent",
  "templateBorder_warning": "DoyeEa_templateBorder_warning",
  "templateCard": "DoyeEa_templateCard",
  "templateDescription": "DoyeEa_templateDescription",
  "templateHeader": "DoyeEa_templateHeader",
  "templateTitle": "DoyeEa_templateTitle",
  "templateTitleRow": "DoyeEa_templateTitleRow",
});
